import { expVal } from '@atlassian/jira-feature-experiments';

export default {
	get(): boolean {
		return expVal('jira_calendar_release_flyout_lazy_loading', 'isEnabled', false);
	},
};
